import { defineMessages, IntlShape } from "react-intl";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";

import { SortField } from "./getSortFieldDisplayName";

const messagesAsc = defineMessages<SortField>({
  [SortField.CREATED_AT]: {
    id: "resources.list.sort.createdAt.asc",
    defaultMessage: "Oldest first",
    description: "Resources list customization sort - Oldest first",
  },
  [SortField.FILE_SIZE]: {
    id: "resources.list.sort.fileSize.asc",
    defaultMessage: "Smallest first",
    description: "Deals card filter option - Smallest first",
  },
  [SortField.NAME]: {
    id: "resources.list.sort.name.asc",
    defaultMessage: "A > Z",
    description: "Resources list customization sort - A > Z",
  },
  [SortField.OWNER]: {
    id: "resources.list.sort.owner.asc",
    defaultMessage: "A > Z",
    description: "Deals card filter option - A > Z",
  },
  [SortField.TYPE]: {
    id: "resources.list.sort.fileType.asc",
    defaultMessage: "A > Z",
    description: "Resources list fileType sort - A > Z",
  },
  [SortField.UPDATED_AT]: {
    id: "resources.list.sort.updatedAt.asc",
    defaultMessage: "Oldest first",
    description: "Resources list customization sort - Oldest first",
  },
});

const messagesDesc = defineMessages<SortField>({
  [SortField.CREATED_AT]: {
    id: "resources.list.sort.createdAt.desc",
    defaultMessage: "Newest first",
    description: "Resources list customization sort - Newest first",
  },
  [SortField.FILE_SIZE]: {
    id: "resources.list.sort.fileSize.desc",
    defaultMessage: "Largest first",
    description: "Deals card filter option - Largest first",
  },
  [SortField.NAME]: {
    id: "resources.list.sort.name.desc",
    defaultMessage: "Z > A",
    description: "Resources list customization sort - Name desc direction",
  },
  [SortField.OWNER]: {
    id: "resources.list.sort.owner.desc",
    defaultMessage: "Z > A",
    description: "Resources list customization sort - Z > A",
  },
  [SortField.TYPE]: {
    id: "resources.list.sort.fileType.desc",
    defaultMessage: "Z > A",
    description: "Resources list fileType sort - Z > A",
  },
  [SortField.UPDATED_AT]: {
    id: "resources.list.sort.updatedAt.desc",
    defaultMessage: "Newest first",
    description: "Resources list customization sort - Newest first",
  },
});

const getSortDirectionNameForField = (
  intl: IntlShape,
  fieldName: SortField,
  order: SortOrder
): string =>
  order === SortOrder.DESC
    ? intl.formatMessage(messagesDesc[fieldName])
    : intl.formatMessage(messagesAsc[fieldName]);

export default getSortDirectionNameForField;
